import React from "react";
import styles from "./index.module.scss";

const BackToTopButton = ({ className, ...props }) => {
	return (
		<button className={`${styles.backToTopButton} ${className}`} {...props}>
			<svg
				width="20"
				height="21"
				viewBox="0 0 20 21"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<title>回到頂部</title>
				<g clipPath="url(#clip0_1440_133)">
					<path
						d="M15.0001 18.8333H10.8334V2.85244L14.4168 6.43578C14.5739 6.58757 14.7844 6.67157 15.0029 6.66967C15.2214 6.66777 15.4304 6.58013 15.5849 6.42562C15.7394 6.27112 15.8271 6.06211 15.829 5.84361C15.8309 5.62511 15.7469 5.41461 15.5951 5.25744L11.4734 1.13578C11.28 0.942265 11.0503 0.788759 10.7975 0.684027C10.5447 0.579296 10.2737 0.525391 10.0001 0.525391C9.72646 0.525391 9.4555 0.579296 9.20271 0.684027C8.94991 0.788759 8.72022 0.942265 8.52676 1.13578L4.40176 5.26078C4.2455 5.41748 4.15789 5.62983 4.1582 5.85112C4.15852 6.07241 4.24672 6.28452 4.40342 6.44078C4.56012 6.59703 4.77248 6.68464 4.99377 6.68433C5.21506 6.68402 5.42717 6.59581 5.58342 6.43911L9.16676 2.85578V18.8333H5.00009C4.77908 18.8333 4.56711 18.9211 4.41083 19.0773C4.25455 19.2336 4.16676 19.4456 4.16676 19.6666C4.16676 19.8876 4.25455 20.0996 4.41083 20.2559C4.56711 20.4121 4.77908 20.4999 5.00009 20.4999H15.0001C15.2211 20.4999 15.4331 20.4121 15.5893 20.2559C15.7456 20.0996 15.8334 19.8876 15.8334 19.6666C15.8334 19.4456 15.7456 19.2336 15.5893 19.0773C15.4331 18.9211 15.2211 18.8333 15.0001 18.8333Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_1440_133">
						<rect
							width="20"
							height="20"
							fill="white"
							transform="translate(0 0.5)"
						/>
					</clipPath>
				</defs>
			</svg>
			<span>TOP</span>
		</button>
	);
};

export default BackToTopButton;
